import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs';
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { environment } from '../../../../environments/environment';
import { MsalService } from '@azure/msal-angular';
@Injectable({
  providedIn: 'root'
})

export class FlowInformationService {
  constructor(
    private httpService: TCCPHttpService, private logger: TCCPLoggerService, public authService: MsalService) { }
  private apiUrl: string;
  public appBase = TCCPConstantValues[environment.applicationName];
  public baseURL = this.appBase.Urls.BASE_URL + '?issueId=';
  public screenshotInfo;

  /** For service call to get flow
   * @class FlowInformationService
   * @method getFlow
   * @param flowId - flow id
   * @returns Observable
   */
  getFlow(flowId: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    return this.httpService.get(this.baseURL + flowId + '&source=' + environment.applicationName).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
      }),
      catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  getDoneFlow(flowId: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getDoneFlow,
      'Started getting flow', '');
    return this.httpService.get(this.appBase.Urls.DONE_URL + '' + environment.applicationName + '/done.json').pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getDoneFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getDoneFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to get document details
* @class AdminService
* @method insertdocument
* @param document Model 
* @returns Observable
*/
  getAllDocuments(): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    const url = this.appBase.Urls.GET_DOCUMENT_URL + '?source=' + environment.applicationName +
      '&contentType=document';
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  getDisclaimer(id): Observable<any> {
    const url = this.appBase.Urls.GET_DISCLAIMER_URL + '?source=' + environment.applicationName + '&contentId=' + id;
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to get flow
  * @class FlowInformationService
  * @method getFlow
  * @param flowId - flow id
  * @returns Observable
  */
  getFlowCount(flowId: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    return this.httpService.get(this.appBase.Urls.GET_STEP_COUNT + '?issueId=' + flowId + '&source=' + environment.applicationName).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

}
